import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-recuperar-contrasenia',
  templateUrl: 'recuperar-contrasenia.html',
})
export class RecuperarContraseniaPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {

  }

  iniciarSesion() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/recuperar-contrasenia/recuperar-contrasenia.ts